import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
export default function addDislikesTabToUserProfile() {
  extend(UserPage.prototype, 'navItems', function (items) {
    const user = this.user;
    items.add('dislikes', m(LinkButton, {
      href: app.route('user.dislikes', {
        username: user?.slug()
      }),
      icon: "far fa-thumbs-down"
    }, app.translator.trans('nodeloc-dislikes.forum.user.dislikes_link')), 88);
  });
}